import { FeatureDTO } from "./FeatureDTO";

export class SharedCalendarFeatureDTO extends FeatureDTO {
    constructor(sub?) {
        super(sub);
    }
}
